import { createSelector } from 'reselect';
import { selectAllProducts } from './selectAllProducts';

const getProductById = (productId) => (products) => {
  return products[productId];
};

export const selectProductFromProductsById = (productId) =>
  createSelector(selectAllProducts, getProductById(productId));
